import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { Paginacao } from '@app/models/util/paginacao';
import { AgendaTelefonicaLista } from '@app/models/agenda-telefonica.model';
import { AgendaTelefonica } from '@app/models/agenda-telefonica.model';
import { AgendaTelefonicaService } from '@app/services/agenda-telefonica.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-telefonica-lista',
  templateUrl: './telefonica-lista.component.html'
})
export class TelefonicaListaComponent implements OnInit {

  @ViewChild('maisInformacoesModal', { static: true }) maisInformacoesModal: TemplateRef<any>;

  agendaTelefonicaTotal: AgendaTelefonica[];
  lstAgendaTelefonica: AgendaTelefonicaLista[];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao = '';
  bsModalRef: BsModalRef;
  agendaTelefonicaUnica: AgendaTelefonica;
  lstagendaTelefonicaUnica: string[];

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private agendaTelefonicaService: AgendaTelefonicaService,
    private modalService: BsModalService) {
    this.agendaTelefonicaUnica = new AgendaTelefonica();
  }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1); // Problema na página 1 -- Dados da agenda telefônica
  }
  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(pesquisa: string, pagina: number) {
    this.agendaTelefonicaService.obterPesquisa(this.filtroDescricao, pagina)
      .toPromise().then(data => {
        this.lstAgendaTelefonica = data.Dados;
        this.paginacao.totalDeItens = data.Total;
      }, erro => {
        //this.loading = false;
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  // deletar(id: number) {
  //   this.agendaTelefonicaService.deletar(id).toPromise().then(data => {
  //     this.obterTodos(this.filtroDescricao, 1);
  //   });
  // };

  deletar(agendaTelefonica: AgendaTelefonicaLista) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente excluir a agenda telefônica: ' + agendaTelefonica.Nome;
    this.bsModalRef.content.confirmar = () => {
      this.agendaTelefonicaService.deletar(agendaTelefonica.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    };
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

  consultar(agendaTelefonica: AgendaTelefonicaLista) {
    this.modalService.show(this.maisInformacoesModal);

    this.agendaTelefonicaService.obterPorId(agendaTelefonica.Id)
      .subscribe(
        data => this.agendaTelefonicaUnica = data);

  }

  fecharModalInfo() {
    this.modalService.hide(1);
  }
}
